"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMetadataPhrase = exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classnames = _interopRequireDefault(require("classnames"));

var _UserName = _interopRequireDefault(require("@insided/deprecated-preact-components/User/UserName"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _globals = require("@insided/shared/utils/globals");

var METADATA_CONTENT_TYPE_PHRASE = {
  // Partial<Record<ContentType,string>> i guess
  idea: 'topic.list.metadata.shared.in',
  article: 'topic.list.metadata.published.in',
  question: 'topic.list.metadata.asked.in'
};
var DEFAULT_METADATA_PHRASE = 'topic.list.metadata.posted.in';

var getMetadataPhrase = function getMetadataPhrase(contentType) {
  if (contentType in METADATA_CONTENT_TYPE_PHRASE) {
    return METADATA_CONTENT_TYPE_PHRASE[contentType];
  }

  return DEFAULT_METADATA_PHRASE;
};

exports.getMetadataPhrase = getMetadataPhrase;

var TopicMetadata = function TopicMetadata(props) {
  var user = props.user,
      userTitle = props.userTitle,
      categoryUrl = props.categoryUrl,
      categoryName = props.categoryName,
      hideCategoryMetadata = props.hideCategoryMetadata,
      contentType = props.contentType;
  var topicCategoryMetadata = getMetadataPhrase(contentType);
  return (0, _preact.h)(_globals.ModulesContext.Consumer, null, function (modules) {
    return (0, _preact.h)("div", {
      className: (0, _classnames.default)('topic-view_header-items-gathered', {
        'topic-view_header-items_without-category': hideCategoryMetadata || !categoryName
      })
    }, (0, _preact.h)("div", {
      className: "topic-view_header-item"
    }, (0, _preact.h)(_UserName.default, {
      user: user,
      extraClass: "username"
    }), userTitle && (0, _preact.h)("span", {
      className: "user-title text--meta"
    }, userTitle)), !hideCategoryMetadata && !!categoryName && (0, _preact.h)("a", {
      href: (0, _absoluteUrlRuntime.resolveUrl)(categoryUrl),
      "data-track-type": "click",
      "data-element-name": "Search result topic header link",
      className: "topic-view_header-item text--meta"
    }, (0, _preact.h)("div", {
      className: "topic-view_header-item text--meta"
    }, (0, _preact.h)("span", null, (0, _preact.h)(_phrase.default, {
      p: topicCategoryMetadata
    })), "\xA0", (0, _preact.h)("span", {
      className: "topic-view_header-item_category-link"
    }, modules.includes('categoriesAsPhrases') ? (0, _preact.h)(_phrase.default, {
      p: categoryName
    }) : categoryName))));
  });
};

var _default = TopicMetadata;
exports.default = _default;